import tzlookup from 'tz-lookup';

// IANA zone of the obra (camera site) from its ubicacionMaps {lat, lng}; null when missing or invalid.
export const getObraTimeZone = (obra) => {
  const location = obra?.ubicacionMaps;
  if (!location || location.lat == null || location.lng == null || location.lat === '' || location.lng === '') {
    return null;
  }
  const lat = Number(location.lat);
  const lng = Number(location.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  try {
    return tzlookup(lat, lng) || null;
  } catch {
    return null;
  }
};
